export const DEFAULT_OFFER_COLOR = '#3b82f6';

/**
 * @param {unknown} hex
 * @returns {string}
 */
export function normalizeOfferColor(hex) {
  if (typeof hex !== 'string') return DEFAULT_OFFER_COLOR;
  const value = hex.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(value)) return value;
  if (/^#[0-9A-Fa-f]{3}$/.test(value)) {
    const r = value[1];
    const g = value[2];
    const b = value[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return DEFAULT_OFFER_COLOR;
}

/**
 * @param {string} hex
 * @param {number} factor
 * @returns {string}
 */
export function darkenHex(hex, factor = 0.15) {
  const color = normalizeOfferColor(hex).slice(1);
  const channel = (start) => Math.max(0, Math.round(parseInt(color.slice(start, start + 2), 16) * (1 - factor)));
  const toHex = (n) => n.toString(16).padStart(2, '0');
  return `#${toHex(channel(0))}${toHex(channel(2))}${toHex(channel(4))}`;
}

/**
 * Palette derived from the chatbot primary color for the offer card.
 * @param {unknown} hex
 */
export function offerColorStyles(hex) {
  const color = normalizeOfferColor(hex);
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);
  const mix = (amount) =>
    `rgb(${Math.round(r * amount)}, ${Math.round(g * amount)}, ${Math.round(b * amount)})`;

  return {
    color,
    hover: darkenHex(color, 0.15),
    card: {
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.08)`,
      borderColor: `rgba(${r}, ${g}, ${b}, 0.28)`
    },
    strong: { color: mix(0.45) },
    body: { color: mix(0.55) },
    muted: { color: mix(0.62) },
    divider: { borderColor: `rgba(${r}, ${g}, ${b}, 0.35)` }
  };
}

/**
 * @param {{ color: string, hover: string }} theme
 */
export function brandButtonProps(theme) {
  return {
    style: { backgroundColor: theme.color },
    onMouseEnter: (event) => {
      if (!event.currentTarget.disabled) {
        event.currentTarget.style.backgroundColor = theme.hover;
      }
    },
    onMouseLeave: (event) => {
      event.currentTarget.style.backgroundColor = theme.color;
    }
  };
}
